(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yg-image"] && !Shopify.designMode) return;
  try {
    class YGImage extends YGImageLazyLoader {
    constructor() {
      super();
    }
    connectedCallback() {
      this.loaderImg();
    }
    get images() {
      return this.querySelectorAll('img[data-src]');
    }

    loaderImg() {
      // 这里放置自定义逻辑
      this.images.forEach((img) => {
        // 安全检查，确保 YGUtils 已加载
        if (this.getLazyLoader) {
          this.getLazyLoader().observe(img);
        } else {
          console.warn('YGUtils 未加载，使用备用图片加载方式');
          // 备用方案：直接设置图片源
          if (img.getAttribute('data-src')) {
            img.src = img.getAttribute('data-src');
            img.removeAttribute('data-src');
          }
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!window.customElements.get('yg-image')) {
      window.customElements.define('yg-image', YGImage);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-popup"] && !Shopify.designMode) return;
  try {
    class YGPopupBox extends HTMLElement {
    constructor() {
      super();
      this.closePopup = this.closePopup.bind(this);
      this.openPopup = this.openPopup.bind(this);
    }

    // 优化：缓存并懒加载元素，只查询一次，提高性能和可维护性
    get sectionsEl() {
      if (this._sectionsEl) return this._sectionsEl;

      this._sectionsEl = {
        'close': this.querySelector('.yg-popup-box-close'),
        'content-inner': this.querySelector('.yg-popup-box-content-inner'),
        'body': document.body,
      };
      
      return this._sectionsEl;
    }

    connectedCallback() {
      this.addEventListener('click', this.closePopup);
      document.addEventListener('YG:openPopup', this.openPopup);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.closePopup);
      document.removeEventListener('YG:openPopup', this.openPopup);
    }

    openPopup(e) {
      const { popupTemplate, popupClass, closeBtnClass } = e.detail || {};
      
      if (!popupTemplate) {
        console.error('popupTemplate is missing');
        return;
      }
      // popupTemplate：需要替换的元素
      if (popupClass) this.classList.add(popupClass);
      if (closeBtnClass) this.sectionsEl['close'].classList.add(closeBtnClass);
      this.sectionsEl['content-inner'].innerHTML = popupTemplate.innerHTML;
      this.sectionsEl['body'].style.overflow = 'hidden';
      this.style.display = 'flex';
    }

    closePopup(e) {
      const closeBtn = e.target.closest('.yg-popup-box-close');
      const popupBox = e.target.closest('.yg-popup-box');
      if (closeBtn || (popupBox && e.target === popupBox)) {
        this.style.display = 'none';
        this.sectionsEl['content-inner'].innerHTML = '';
        this.sectionsEl['body'].style.overflow = 'auto';
        this.sectionsEl['close'].className = 'yg-popup-box-close';
        this.className = 'yg-popup-box';
      }
    } 
  }
  if (!window.customElements.get('yg-popup-box')) {
    window.customElements.define('yg-popup-box', YGPopupBox);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-product-others"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.torrasDirectModelNavigationReady) return;
    window.torrasDirectModelNavigationReady = true;

    var dropdowns = new Set();

    function closeOthers(current) {
      dropdowns.forEach(function (dropdown) {
        if (!dropdown.isConnected) {
          dropdowns.delete(dropdown);
        } else if (dropdown !== current) {
          dropdown.open = false;
        }
      });
    }

    function init(scope) {
      scope.querySelectorAll('details.torras-device-dropdown').forEach(function (dropdown) {
        if (dropdowns.has(dropdown)) return;
        dropdowns.add(dropdown);

        dropdown.querySelectorAll('.torras-device-dropdown__option[href]').forEach(function (option) {
          option.addEventListener('click', function (event) {
            if (event.defaultPrevented || event.button !== 0) return;
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            if (option.hasAttribute('download')) return;
            var target = option.getAttribute('target');
            if (target && target.toLowerCase() !== '_self') return;

            var destination;
            try {
              destination = new URL(option.href, window.location.href);
            } catch (error) {
              return;
            }
            if (destination.origin !== window.location.origin) return;
            if (destination.protocol !== 'https:' && destination.protocol !== 'http:') return;

            event.preventDefault();
            if (destination.href === window.location.href) {
              dropdown.open = false;
              dropdown.querySelector('summary').focus();
              return;
            }

            window.location.href = destination.href;
          });
        });

        dropdown.addEventListener('toggle', function () {
          if (dropdown.open) closeOthers(dropdown);
        });

        dropdown.addEventListener('keydown', function (event) {
          if (!(event.target instanceof Element)) return;
          var summary = dropdown.querySelector('summary');
          if (event.key === 'Escape') {
            if (!dropdown.open) return;
            event.preventDefault();
            dropdown.open = false;
            summary.focus();
            return;
          }
          if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;

          var options = Array.from(dropdown.querySelectorAll('.torras-device-dropdown__option[href]'));
          if (!options.length) return;
          event.preventDefault();
          dropdown.open = true;
          closeOthers(dropdown);

          var index = options.indexOf(document.activeElement);
          var next;
          if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = options.length - 1;
          else if (index < 0) {
            next = options.findIndex(function (option) {
              return option.classList.contains('is-active');
            });
            if (next < 0) next = event.key === 'ArrowUp' ? options.length - 1 : 0;
          } else {
            next = (index + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
          }
          options[next].focus();
        });
      });
    }

    document.addEventListener('click', function (event) {
      if (!(event.target instanceof Element)) return;
      closeOthers(event.target.closest('details.torras-device-dropdown'));
    });

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target instanceof Element) init(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      dropdowns.forEach(function (dropdown) {
        if (event.target instanceof Element && event.target.contains(dropdown)) {
          dropdowns.delete(dropdown);
        }
      });
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      }, { once: true });
    } else {
      init(document);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-tabs"] && !Shopify.designMode) return;
  try {
    class YGTabsTitle extends HTMLElement {
      constructor() {
          super()
      }

      get sectionsEl() {
        if (this._sectionsEl) return this._sectionsEl;

        this._sectionsEl = {
          'title-list': Array.from(this.children),
          'content-list': Array.from(document.querySelector(`yg-tabs-content[data-id='${this.dataset.id}']`)?.children || [])
        };

        return this._sectionsEl;
      }

      connectedCallback() {
        this.initTabs()
        this.addEventListener('click', (e) => {
          let item = e.target.closest('.tab-title');
          if (item) {
            let i = this.sectionsEl['title-list'].indexOf(item);
            this.itemClick(item, i);
          }
        });
      }

      initTabs() {
        let activeIndex = this.sectionsEl['title-list'].findIndex((el) => el.classList.contains('is-active'));
        if (activeIndex < 0) activeIndex = 0;

        this.sectionsEl['title-list']?.forEach((el, i) => {
          if (!el.classList.contains('tab-title')) {
            el.classList.add('tab-title');
          }
          
          if (i == activeIndex) {
            el.classList.add('is-active');
          } else {
            el.classList.remove('is-active');
          }
        });
        this.updateStyle(this.sectionsEl['title-list'][activeIndex]);

        this.sectionsEl['content-list'].forEach((el, i) => {
          if (!el.classList.contains('tab-content')) {
            el.classList.add('tab-content');
          }

          if (i == activeIndex) {
            el.classList.add('is-active');
          } else {
            el.classList.remove('is-active');
          }
        });
      }

      itemClick(el, i) {
        // 如果已经激活则直接返回
        if (el.classList.contains('is-active')) return;

        // el.scrollIntoView({ behavior: 'smooth', inline: 'center', container: 'nearest' });
        this.toggleClass(el, i)
      }

      toggleClass(el, i) {
        // 处理标题激活状态
        this.sectionsEl['title-list'].forEach((item) => {
          item.classList.remove('is-active');
        });
        el.classList.add('is-active');
        this.updateStyle(el);

        // 处理内容激活状态
        this.sectionsEl['content-list'].forEach((item) => {
          item.classList.remove('is-active');
        });
        if (this.sectionsEl['content-list'][i])
          this.sectionsEl['content-list'][i].classList.add('is-active');
      }

      updateStyle(el = null) {
        let itemEl = el || this.querySelector('.is-active');

        if (!itemEl) return;
        let left = itemEl.offsetLeft;
        let width = itemEl.offsetWidth;
        this.style.setProperty('--scroll-item-left', `${left}px`);
        this.style.setProperty('--scroll-item-width', `${width}px`);
      }
  }
  if (!window.customElements.get('yg-tabs-title')) {
      window.customElements.define('yg-tabs-title', YGTabsTitle)
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-video"] && !Shopify.designMode) return;
  try {
    class YGVideo extends YGVideoLazyLoader {
    constructor() {
      super();
      this.playVideoClick = this.playVideo.bind(this);
      this.autoplay = this.getAttribute('data-autoplay');
      this.popup = this.getAttribute('data-popup');
      this.type = this.getAttribute('data-type');
      this.isMuted = true;
      this._isPreloaded = false;
      this._hasReadyFrame = false;
    }

    get videoContainer() {
      return this.querySelector('.yg-video-iframe-container');
    }

    get image() {
      return this.querySelector('.yg-video-placeholder');
    }

    get template() {
      return Array.from(this.children).find(child => child.tagName === 'TEMPLATE');
    }

    get playVideoButton() {
      return this.querySelector('.yg-play-video');
    }

    connectedCallback() {
      this.playVideoButton?.addEventListener('click', this.playVideoClick);
      this.activateResponsiveVideoSource();
      if (this.autoplay == 'true' && this.popup == 'false') {
        this.getLazyLoader().observe(this);
      }
    }

    // Override: when entering viewport, inject template but do NOT play.
    getLazyLoader() {
      if (!this._lazyLoader) {
        this._lazyLoader = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.preloadInView();
              observer.unobserve(this);
            }
          });
        }, {
          rootMargin: '50px',
        });
      }
      return this._lazyLoader;
    }

    // Injects template + applies mute attrs without playing.
    preloadInView() {
      if (this._isPreloaded || !this.template) return;
      this.appendChild(this.template.content.cloneNode(true));
      this.activateResponsiveVideoSource();
      this.applyMuteStateToVideos();
      this.bindVideoReadyHandlers();
      this._isPreloaded = true;
    }

    activateResponsiveVideoSource() {
      const container = this.videoContainer;
      if (!container || container.querySelector('.yg-video-iframe')) return;

      const desktopTemplate = container.querySelector('template[data-yg-video-desktop]');
      const mobileTemplate = container.querySelector('template[data-yg-video-mobile]');
      if (!desktopTemplate && !mobileTemplate) return;

      const isMobile = window.matchMedia('(max-width: 699px)').matches;
      const selectedTemplate = (isMobile ? mobileTemplate : desktopTemplate) || desktopTemplate || mobileTemplate;
      if (!selectedTemplate) return;

      container.appendChild(selectedTemplate.content.cloneNode(true));
      desktopTemplate?.remove();
      mobileTemplate?.remove();
    }

    applyMuteStateToVideos() {
      if (this.type !== 'video' || !this.videoContainer) return;
      const videos = this.videoContainer.querySelectorAll('.yg-video-iframe');
      if (!videos.length) return;
      videos.forEach(video => {
        video.muted = this.isMuted;
      });
    }

    ensureInlineAndMuted(videoEl) {
      // Mobile autoplay policy: must be muted and inline (especially iOS Safari).
      if (!videoEl) return;
      videoEl.muted = this.isMuted;
      videoEl.setAttribute('muted', '');
      videoEl.setAttribute('playsinline', '');
      videoEl.setAttribute('webkit-playsinline', '');
    }

    playNativeVideos() {
      if (this.type !== 'video' || !this.videoContainer) return;
      const videos = this.videoContainer.querySelectorAll('.yg-video-iframe');
      if (!videos.length) return;

      if (!this._hasReadyFrame) {
        this.classList.add('is-loading');
      }

      this.videoContainer.classList.add('active');
      this.bindVideoReadyHandlers();
      videos.forEach((video) => {
        this.ensureInlineAndMuted(video);
        const p = video.play();
        // Avoid unhandled promise rejection on mobile browsers when autoplay is blocked.
        if (p && typeof p.catch === 'function') p.catch(() => {});
      });
    }

    bindVideoReadyHandlers() {
      if (this.type !== 'video' || !this.videoContainer) return;
      const videos = this.videoContainer.querySelectorAll('.yg-video-iframe');
      if (!videos.length) return;

      videos.forEach((video) => {
        if (video.__yg_ready_bound) return;

        const markReady = () => {
          this._hasReadyFrame = true;
          this.classList.remove('is-loading');
        };

        video.__yg_ready_bound = true;
        video.addEventListener('loadeddata', markReady, { once: true });
        video.addEventListener('canplay', markReady, { once: true });
        video.addEventListener('playing', markReady, { once: true });

        if (video.readyState >= 2) {
          markReady();
        }
      });
    }

    playVideo() {
      if (this.popup == 'true') {
        this.dispatchEvent(
          new CustomEvent('YG:openPopup', {
            bubbles: true,
            detail: {
              popupTemplate: this.template,
            },
          })
        );

        return;
      }

      this.image?.classList.remove('active');
      this.playVideoButton?.classList.add('hide');

      // If content is already in DOM (preloaded via viewport or already played), play immediately.
      if (this._isPreloaded && this.videoContainer) {
        this.activateResponsiveVideoSource();
        this.playNativeVideos();
        return;
      }

      // Otherwise, inject template content then try to play (mobile autoplay might require explicit play()).
      this.appendChild(this.template?.content.cloneNode(true));
      this.activateResponsiveVideoSource();
      this.applyMuteStateToVideos();
      this._isPreloaded = true;
      this.playNativeVideos();
    }

    toggleMute(buttonEl) {
      this.isMuted = !this.isMuted;
      this.applyMuteStateToVideos();
      this.updateMuteButtonState(buttonEl);
    }

    updateMuteButtonState(buttonEl) {
      if (!buttonEl) return;

      if (this.isMuted) {
        buttonEl.classList.add('is-muted');
        buttonEl.setAttribute('aria-pressed', 'true');
      } else {
        buttonEl.classList.remove('is-muted');
        buttonEl.setAttribute('aria-pressed', 'false');
      }
    }

    pauseVideo() {
      this.image?.classList.add('active');
      this.playVideoButton?.classList.remove('hide');
      
      if (this.type == 'video' && this.videoContainer) {
        let videos = this.videoContainer.querySelectorAll('.yg-video-iframe');
        this.videoContainer.classList.remove('active');
        this.classList.remove('is-loading');

        videos.forEach(video => {
          video.pause();
          // video.currentTime = 0.001;
        });
      } else {
        this.videoContainer?.remove();
      }
    }
  }
  document.addEventListener('DOMContentLoaded', () => {
    if (!window.customElements.get('yg-video')) {
      window.customElements.define('yg-video', YGVideo);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
